module.exports = __webpack_public_path__ + "img/banner-1.90523d01.png";